export enum OfferModalActiveTab {
    GALLERY = 1,
    MAP = 2,
    PLAN = 3,
    CONSTRUCTION_GALLERY = 4
}
export enum OfferModalActiveTab {
    GALLERY = 1,
    MAP = 2,
    PLAN = 3,
    CONSTRUCTION_GALLERY = 4
}
